import React, { useState, useEffect } from "react";
import { Grid, Box, Typography, TextField, IconButton } from "@mui/material";
import { useSelector } from "react-redux";
import AudioButton from "../../Components/Media/AudioButton";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { makeStyles } from "@material-ui/core/styles";

const TeacherComment = (props) => {
    console.log("props===",props);
    const styles = useStyles();
    const [isPlaying, setIsPlaying] = useState(false);

    let reaction = props.attempedAnsLog.reaction;
    let teacherReaction = '';

    if (reaction == 'care')
      teacherReaction = 'fillCare';
    else if (reaction == 'like')
      teacherReaction = 'fillLike';
    else if (reaction == 'star')
      teacherReaction = 'fillStar';

    // Load Dynamic Image
    const loadImage = (reactionName) => {
        switch (reactionName) {
        case 'fillCare':
            return require('../../assets/fill/care.png');
        case 'outlineCare':
            return require('../../assets/outline/care.png');
        case 'fillLike':
            return require('../../assets/fill/like.png');
        case 'outlineLike':
            return require('../../assets/outline/like.png');
        case 'fillStar':
            return require('../../assets/fill/star.png');
        case 'outlineStar':
            return require('../../assets/outline/star.png');
        case "default":
            return ``;
        }
    }

    return(
        <Grid container sx={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
        <Grid xs={3}>
          <Typography sx={{ color: '#DB8829', fontWeight: '500', fontSize: '1.2rem' }}>Teacher Comments :</Typography>
        </Grid>
        <Grid item xs={9} sx={{ ma: 2, backgroundColor: '#DB8829', borderRadius: 10, px: 3 }}>
          <Grid container sx={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', my: 1 }}>
            <Grid item sx={{ flexDirection: 'row', display: 'flex' }}>
              <Box>
                <TextField
                  size="small"
                  sx={[{ width: '40vw', border: '1px solid #FFFFFF', backgroundColor: '#FFFFFF', borderRadius: 1 }]}
                  placeholder={"Comment..."}
                  placeholderTextColor="#FFFFFF"
                  value={props.attempedAnsLog.comments}
                />
              </Box>
            </Grid>
            <Grid item sx={{ display: 'flex' }}>
                {props.attempedAnsLog.teacherRec &&
                    <Box>
                        <AudioButton
                        userAnswer={props.attempedAnsLog.teacherRec}
                        playStatus={(status)=>{setIsPlaying(status)}}
                        >          
                            <IconButton sx={{
                                mx: 1,
                                border: 1,
                                borderColor: "#EFEFEF",
                                backgroundColor: "primary.main",
                                boxShadow: 2,
                                color: "#FFFFFF",
                               
                            }}
                            size={props.size ? props.size : "medium"}>
                                {isPlaying ? (
                                    <PauseIcon
                                    sx={{
                                        "@media (min-width: 1636px)": {
                                        fontSize: "2rem",
                                        },
                                    }}
                                    />
                                ) : (
                                    <PlayArrowIcon
                                    sx={{
                                        "@media (min-width: 1636px)": {
                                        fontSize: "2rem",
                                        },
                                    }}
                                    />
                                )}
                            </IconButton>
                        </AudioButton>
                    </Box>
                }
            </Grid>
            <Grid item sx={{ display: 'flex' }}>
              <Box>
                <img src={loadImage(teacherReaction)} className={styles.RewardImg}></img>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>  
    );
};

const useStyles = makeStyles({
    RewardImg: {
        width: '1.9rem',
        '@media (min-width: 1636px)': {
        width: '2.5rem',
        }
    }
});

export default TeacherComment;